import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class SendEmailToVerifyUserUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {UseCase} deps.service
   * @param {Object} deps.log
   */
  constructor({userRepository, getCurrentUserService, userNotLoggedInUserErrorFactory}) {
    super()

    this._userRepository = userRepository
    this._getCurrentUserService = getCurrentUserService
    this._userNotLoggedInUserErrorFactory = userNotLoggedInUserErrorFactory
  }

  getCurrentUser = async () => {
    const currentUser = await this._getCurrentUserService.execute()
    return currentUser || null
  }

  @inlineError
  async execute({redirectUri} = {}) {
    const currentUser = await this.getCurrentUser()

    if (!currentUser)
      throw this._userNotLoggedInUserErrorFactory({
        message: `[GetUserByIdUserService#get] user not logged`
      }).toJSON()

    const [error, response] = await this._userRepository.sendEmailToVerifyUser({
      currentUser,
      redirectUri
    })

    if (error) throw error
    return response
  }
}
